import { IAppState } from '../../common/state';

export function getNewbuildingSeoDescription({ newbuildingInformation }: IAppState): string | undefined {
  return newbuildingInformation?.seoDescription;
}
